import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "fn_bid_confirmation-modal",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "fn_bid_confirmation-modal-label",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog modal-md modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "d-sm-flex pt-3" }
const _hoisted_6 = { class: "flex-fill align-self-center" }
const _hoisted_7 = {
  key: 0,
  class: "alert alert-light mt-3"
}
const _hoisted_8 = { class: "mb-0" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "custom-control custom-checkbox mt-3" }

import { ref, watch, onMounted } from 'vue'
import Modal from 'bootstrap.native/src/components-v4/modal-native';


export default {
  __name: 'BidConfirmation',
  props: {
	showModal: { required: true },
	auction: { required: true },
	user: { required: true },
	bidAmount: { required: true },
	currencySymbol: { required: true },
	urlBecomePremium: { required: true },
},
  emits: ['submit', 'closed'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

const confirmationDismiss = ref(false);

let modal = null;

onMounted(() => {
	const modalEl = document.getElementById('fn_bid_confirmation-modal');
	if (modal === null) {
		modal = new Modal(modalEl);
		modalEl.addEventListener('hide.bs.modal', () => {
			emit('closed');
		});
	}
});

watch(() => props.showModal, (newVal, oldVal) => {
	if (newVal) {
		modal.show();
	} else {
		modal.hide();
		emit('closed');
	}
})

function submitBid() {
	modal.hide();
	emit('closed');
	emit('submit', confirmationDismiss);
}


return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "modal-header" }, [
          _createElementVNode("p", {
            class: "modal-title h1 mb-0",
            id: "fn_bid_confirmation-modal-label"
          }, "Potvrďte svůj příhoz"),
          _createElementVNode("button", {
            type: "button",
            class: "modal-close",
            "data-dismiss": "modal",
            "aria-label": "Zavřít"
          })
        ], -1 /* HOISTED */)),
        _createElementVNode("div", _hoisted_4, [
          _cache[6] || (_cache[6] = _createElementVNode("p", { class: "mb-0" }, "Příhozem v aukci se zavazujete uhradit danou částku v případě výhry v aukci.", -1 /* HOISTED */)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[1] || (_cache[1] = _createTextVNode("Váš příhoz: ")),
              _createElementVNode("strong", null, _toDisplayString(__props.bidAmount) + " " + _toDisplayString(__props.currencySymbol), 1 /* TEXT */)
            ]),
            _createElementVNode("div", { class: "flex-fill align-self-center text-sm-right mt-1 mt-sm-0" }, [
              _createElementVNode("button", {
                type: "button",
                onClick: submitBid,
                class: "btn btn-primary"
              }, "Potvrzuji a závazně přihazuji")
            ])
          ]),
          (__props.user.customer === null || __props.user.customer.tariff === 'free')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _cache[4] || (_cache[4] = _createElementVNode("p", { class: "mb-0" }, [
                  _createElementVNode("strong", null, "Automatické příhozy? Přidejte se do Rostlinného klubu")
                ], -1 /* HOISTED */)),
                _createElementVNode("p", _hoisted_8, [
                  _cache[2] || (_cache[2] = _createTextVNode("Členové Rostlinného klubu šetří své peníze pomocí automatických příhozů. Nastaví si maximální částku kterou chtějí zaplatit a systém pak přihazuje za ně. Nepřihazují více, než je nutné a nepřichází o rostliny, když nemohou být u konce aukce. Zkuste to také. :) ")),
                  _createElementVNode("a", { href: __props.urlBecomePremium }, "Přidejte se k nám do klubu", 8 /* PROPS */, _hoisted_9),
                  _cache[3] || (_cache[3] = _createTextVNode("."))
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              class: "custom-control-input",
              id: "fn_bid_confirmation-dismiss",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((confirmationDismiss).value = $event)),
              name: "dismiss",
              value: "1"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelCheckbox, confirmationDismiss.value]
            ]),
            _cache[5] || (_cache[5] = _createElementVNode("label", {
              class: "custom-control-label",
              for: "fn_bid_confirmation-dismiss"
            }, "U této aukce už nezobrazovat potvrzovací okno", -1 /* HOISTED */))
          ])
        ])
      ])
    ])
  ]))
}
}

}